/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserGroup } from './UserGroup';
import {
    UserGroupFromJSON,
    UserGroupFromJSONTyped,
    UserGroupToJSON,
} from './UserGroup';
import type { UsersFindAllResponse } from './UsersFindAllResponse';
import {
    UsersFindAllResponseFromJSON,
    UsersFindAllResponseFromJSONTyped,
    UsersFindAllResponseToJSON,
} from './UsersFindAllResponse';

/**
 * 
 * @export
 * @interface MentionSuggestionsResponse
 */
export interface MentionSuggestionsResponse {
    /**
     * 
     * @type {UsersFindAllResponse}
     * @memberof MentionSuggestionsResponse
     */
    users: UsersFindAllResponse;
    /**
     * 
     * @type {Array<UserGroup>}
     * @memberof MentionSuggestionsResponse
     */
    user_groups: Array<UserGroup>;
    /**
     * 
     * @type {boolean}
     * @memberof MentionSuggestionsResponse
     */
    user_groups_has_more: boolean;
}

/**
 * Check if a given object implements the MentionSuggestionsResponse interface.
 */
export function instanceOfMentionSuggestionsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "users" in value;
    isInstance = isInstance && "user_groups" in value;
    isInstance = isInstance && "user_groups_has_more" in value;

    return isInstance;
}

export function MentionSuggestionsResponseFromJSON(json: any): MentionSuggestionsResponse {
    return MentionSuggestionsResponseFromJSONTyped(json, false);
}

export function MentionSuggestionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MentionSuggestionsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'users': UsersFindAllResponseFromJSON(json['users']),
        'user_groups': ((json['user_groups'] as Array<any>).map(UserGroupFromJSON)),
        'user_groups_has_more': json['user_groups_has_more'],
    };
}

export function MentionSuggestionsResponseToJSON(value?: MentionSuggestionsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'users': UsersFindAllResponseToJSON(value.users),
        'user_groups': ((value.user_groups as Array<any>).map(UserGroupToJSON)),
        'user_groups_has_more': value.user_groups_has_more,
    };
}

